var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarLogoMenu'),_c('SidebarActionMenu'),_c('SidebarMainMenu'),_c('UserOptions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }